const twColors = require('tailwindcss/colors')

const colors = {
  ...twColors,
  primary: '#003057',
  secondary: '#3EB1C8',
  orange: '#FAB526',
  blue1: '#C4E7EE',
  blue2: '#B1E0E9',
  blue3: '#EBF7F9',
  blue4: '#D8EFF4',
  white: '#FFFFFF',
  transparent: 'transparent',
}

/**
 * Bg Images
 */
const imagesBg = {
  'footer' : "footer.jpg",
}

/**
 * Logo sizes
 */
const logoHeight = '160px'
const logoMidHeight = '100px'
const logoMobHeight = '3em'

/**
 * Nav bar
 */
const navBorderHeight = '5px'

/**
 * Make all sizes
 */
const assetImagesUrl = image => `url('/images/${image}')`
const backgroundImage = {}
const imagesSizes = [ 'md', 'lg', 'xl', '2xl' ]
for ( image in imagesBg ){
  backgroundImage[ image ] = assetImagesUrl( imagesBg[image] )
  imagesSizes.map( size => {
    backgroundImage[ `${image}-${size}` ] = assetImagesUrl( `${size}_${imagesBg[image]}` )
  })
}

module.exports = {
  mode: 'jit',
  purge: {
    content: [
      './storage/framework/views/*.php',
      './resources/**/*.blade.php',
      './resources/**/*.js',
      './resources/**/*.vue',
    ],
    options: {
      keyframes: true,
      fontFace: true,
    },
  },
  darkMode: false,
  theme: {
    colors,
    container: {
      center : true,
    },
    fontFamily: {
      montserrat : [
        'Montserrat', 'sans-serif'
      ],
    },
    extend: {
      backgroundImage: theme => ( backgroundImage ),
      fill : {
        current: 'currentColor',
        ...colors,
      },
      flex: {
        '1/4' : '0 0 25%',
        'inner' : '0 0 auto',
      },
      fontSize: {
        'xxs' : '0.55rem;line-height:0.75rem;',
      },
      transitionProperty: {
        'left-right': 'left right',
        'bottom': 'bottom',
        'top': 'top',
        'top-left': 'top left',
        'right': 'right',
        'left': 'left',
        'height': 'height',
        'slide' : 'left right',
        'border' : 'border',
      },
      maxHeight : {
        'modal' : '75vh',
      },
      maxWidth : {
        'body' : '1920px',
        'center' : '1140px',
        'modal' : '95vw',
      },
      padding: {
        'logo' : logoHeight,
      },
      height: {
        'logo' : logoHeight,
        'logo-mob' : logoMobHeight,
        'logo-md' : logoMidHeight,
        'nav-border' : navBorderHeight,
      },
      dropShadow: {
        dark : '0 0 10px black',
      },
    },
  },
  variants: {
    extend: {},
  },
  plugins: [
    require('@tailwindcss/forms')({
      strategy: 'class',
    }),
  ],
}

